import {
	useBlockProps,
	RichText,
	RichTextToolbarButton,
} from "@wordpress/block-editor";
import { useSelect } from "@wordpress/data";
import { __ } from "@wordpress/i18n";
import { registerFormatType, toggleFormat } from "@wordpress/rich-text";

import "./editor.scss";

const PromptButton = ({ isActive, onChange, value }) => {
	const selectedBlock = useSelect((select) => {
		return select("core/block-editor").getSelectedBlock();
	}, []);

	if (selectedBlock && selectedBlock.name !== "codesue/terminal-block") {
		return null;
	}

	const onClickPrompt = () => {
		onChange(
			toggleFormat(value, {
				type: "terminal-block/prompt",
			})
		);
	};

	return (
		<RichTextToolbarButton
			icon="arrow-right-alt2"
			title={__("Set as prompt", "terminal-block")}
			onClick={onClickPrompt}
			isActive={isActive}
		/>
	);
};

registerFormatType("terminal-block/prompt", {
	title: "Prompt",
	tagName: "span",
	className: "prompt",
	edit: PromptButton,
});

export default function edit({ attributes, setAttributes }) {
	const onChangeContent = (content) => {
		setAttributes({ content });
	};

	return (
		<RichText
			{...useBlockProps()}
			tagName="div"
			onChange={onChangeContent}
			value={attributes.content}
			multiline={true}
			allowedFormats={[
				"core/bold",
				"core/italic",
				"core/text-color",
				"terminal-block/prompt",
			]}
			placeholder={__("Write your text...", "terminal-block")}
		/>
	);
}
